

<!-- (ngSubmit)="onSubmit(templateForm)" -->
<form *ngIf="templateForm"  [formGroup]="templateForm"  class="content-card">
  <mat-card class="wide-form-80-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Total Card Order email template</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <input matInput placeholder="Template name" formControlName="name" required>
      </mat-form-field>
      <div style="margin-bottom: 10px;">
        <button class="mr-1" mat-flat-button [disabled]="selectedLanguage === 0" (click)="selectLanguage(0)"><flag-icon [country]="'de'"></flag-icon> German</button>
        <button class="mr-1" mat-flat-button [disabled]="selectedLanguage === 1" (click)="selectLanguage(1)"><flag-icon [country]="'gb'"></flag-icon> English</button>
        <button class="mr-1" mat-flat-button [disabled]="selectedLanguage === 2" (click)="selectLanguage(2)"><flag-icon [country]="'es'"></flag-icon> Spanish</button>
        <button class="mr-1" mat-flat-button [disabled]="selectedLanguage === 3" (click)="selectLanguage(3)"><flag-icon [country]="'it'"></flag-icon> Italian</button>
        <button class="mr-1" mat-flat-button [disabled]="selectedLanguage === 4" (click)="selectLanguage(4)"><flag-icon [country]="'fr'"></flag-icon> French</button>

      </div>


      <div [hidden]="selectedLanguage != 0">
        <mat-form-field >
          <input matInput placeholder="Message subject" formControlName="subject" required>
        </mat-form-field>
      </div>

      <div [hidden]="selectedLanguage != 1">
        <mat-form-field >
          <input matInput placeholder="Message subject" formControlName="subjectEn" required>
        </mat-form-field>
      </div>

      <div [hidden]="selectedLanguage != 2">
        <mat-form-field >
          <input matInput placeholder="Message subject" formControlName="subjectEs" required>
        </mat-form-field>
      </div>

      <div [hidden]="selectedLanguage != 3">
        <mat-form-field >
          <input matInput placeholder="Message subject" formControlName="subjectIt" required>
        </mat-form-field>
      </div>

      <div [hidden]="selectedLanguage != 4">
        <mat-form-field >
          <input matInput placeholder="Message subject" formControlName="subjectFr" required>
        </mat-form-field>
      </div>


      <div [hidden]="true" class="template-var-group">
        <button *ngFor="let cmd of commands" mat-raised-button class="template-var-item" color="primary" type="button"
          (click)="insert(cmd.name)">{{cmd.title}}</button>
      </div>

      <app-html-editor [hidden]="true" placeholder="Enter message template" formControlName="html" required></app-html-editor>

      <div>
        <app-grapesjs-editor [commands]="commands" [mjml]="mjml" (onSaved)="saveFromEditor($event)" #sharedgjs></app-grapesjs-editor>
      </div>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h5>current template</h5>
        </mat-expansion-panel-header>

        <iframe width="100%" height="500" #iframeD></iframe>

      </mat-expansion-panel>


    </mat-card-content>
    <mat-card-actions align="end">
      <!--<button mat-raised-button color="primary" type="button" (click)="generatePdf()">Download preview</button>-->
      <div fxFlex></div>
      <a mat-raised-button style="margin-right: 20px;" color="accent" type="button" routerLink="../..">Cancel</a>
      <button mat-raised-button color="primary" style="margin-right: 10px;" (click)="save()">Save</button>
      <!--<button mat-raised-button color="accent" (click)="go()">Edit</button>-->

    </mat-card-actions>
  </mat-card>
</form>

<div *ngIf="false">
  <button mat-raised-button color="primary" type="button" (click)="generatePdf()">Download preview</button>
  <div fxFlex></div>
  <a mat-raised-button color="accent"  type="button" routerLink="../..">Cancel</a>
  <button mat-raised-button color="primary" type="submit" [disabled]="!templateForm.valid">Save</button>
</div>
